export enum DashboardActionType {
  MY_INFO = "MY_INFO",
  RESEND_TICKET = "RESEND_TICKET",
  TICKET_TRANSFER = "TICKET_TRANSFER",
  PURCHASE_TICKET = "PURCHASE_TICKET",
  MANAGE_TICKETS = "MANAGE_TICKETS",
  MANAGE_ORGANIZATION_ADMINS = "MANAGE_ORGANIZATION_ADMINS",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  TERMS_OF_PARTICIPATION = "TERMS_OF_PARTICIPATION",
  POST_ON_SOCIAL_MEDIA = "POST_ON_SOCIAL_MEDIA",
  VIEW_PURCHASE_HISTORY = "VIEW_PURCHASE_HISTORY",
  EVENT_AGENDA = "EVENT_AGENDA",
  MY_ACTIONS = "MY_ACTIONS",
  MY_AGENDA = "MY_AGENDA",
  TECH_CHECK = "TECH_CHECK",
  VIEW_MY_PROFILE = "VIEW_MY_PROFILE",
  VIEW_ORG_PROFILE = "VIEW_ORG_PROFILE",
  VIEW_TIMELINE = "VIEW_TIMELINE",
  BUY_HOSTED_MEETINGS = "BUY_HOSTED_MEETINGS",
  MANAGE_PARTICIPANTS = "MANAGE_PARTICIPANTS",
  MY_AVAILABILITY = "MY_AVAILABILITY",
  MEETING_REP_AVAILABILITY = "MEETING_REP_AVAILABILITY",
  INSUFFICIENT_MEETING_REP = "INSUFFICIENT_MEETING_REP",
  COMPLETE_ORG_PROFILE = "COMPLETE_ORG_PROFILE",
  COMPLETE_EXHIBITOR_PROFILE = "COMPLETE_EXHIBITOR_PROFILE",
  COMPLETE_ORG_PARTICIPANT_PROFILE = "COMPLETE_ORG_PARTICIPANT_PROFILE",
  COMPLETE_PROFILE = "COMPLETE_PROFILE",
  ADDITIONAL_CHARGE = "ADDITIONAL_CHARGE",
  REQUEST_BY_PARTICIPANT = "REQUEST_BY_PARTICIPANT",
  REQUEST_AND_OPT_IN_BY_PARTICIPANT = "REQUEST_AND_OPT_IN_BY_PARTICIPANT",
  OPT_IN_BY_PARTICIPANT = "OPT_IN_BY_PARTICIPANT",
  REQUEST_BY_ORG_ADMIN = "REQUEST_BY_ORG_ADMIN",
  REQUEST_AND_OPT_IN_BY_ORG_ADMIN = "REQUEST_AND_OPT_IN_BY_ORG_ADMIN",
  OPT_IN_BY_ORG_ADMIN = "OPT_IN_BY_ORG_ADMIN",
  ATTEND_SCHEDULED_MEETINGS = "ATTEND_SCHEDULED_MEETINGS",
  ATTEND_SCHEDULED_MEETINGS_EVENT_PARTICIPANT = "ATTEND_SCHEDULED_MEETINGS_EVENT_PARTICIPANT",
  ACCEPT_MEETINGS = "ACCEPT_MEETINGS",
  VIEW_PARTICIPANT_SCHEDULED_MEETINGS = "VIEW_PARTICIPANT_SCHEDULED_MEETINGS",
  ACCEPT_ADDITIONAL_MEETINGS = "ACCEPT_ADDITIONAL_MEETINGS",
  ASSIGN_MEETING_REP = "ASSIGN_MEETING_REP",
  VIEW_PARTICIPANT_ADDITIONAL_SCHEDULED_MEETINGS = "VIEW_PARTICIPANT_ADDITIONAL_SCHEDULED_MEETINGS",
  VIEW_PARTICIPANT_CONFIRMED_MEETINGS = "VIEW_PARTICIPANT_CONFIRMED_MEETINGS",
  MY_SCHEDULE = "MY_SCHEDULE",
  SHARE_RECEIPTS = "SHARE_RECEIPTS",
  SHARE_FEEDBACK = "SHARE_FEEDBACK",
  FEEDBACK = "FEEDBACK",
  VIEW_PARTICIPANT_FEEDBACK = "VIEW_PARTICIPANT_FEEDBACK",
  MEETINGS_SUMMARY_REPORT = "MEETINGS_SUMMARY_REPORT",
  ORGANIZATION_MEETINGS_SUMMARY_REPORT = "ORGANIZATION_MEETINGS_SUMMARY_REPORT",
  OPT_IN_REIMBURSEMENT = "OPT_IN_REIMBURSEMENT",
  OPT_OUT_REIMBURSEMENT = "OPT_OUT_REIMBURSEMENT",
  REQUEST_AND_OPT_IN_OF_ORGANIZATION_BY_PARTICIPANT = "REQUEST_AND_OPT_IN_OF_ORGANIZATION_BY_PARTICIPANT",
  REQUEST_AND_OPT_IN_OF_ORGANIZATION_BY_ORG_ADMIN = "REQUEST_AND_OPT_IN_OF_ORGANIZATION_BY_ORG_ADMIN",
  COMPLETE_ACTIVITY_PROFILE = "COMPLETE_ACTIVITY_PROFILE",
  COMPLETE_ACTIVITY_SELECTION = "COMPLETE_ACTIVITY_SELECTION",
  ACCEPT_SCHEDULED_ACTIVITY = "ACCEPT_SCHEDULED_ACTIVITY",
  MANAGE_SCHEDULED_ACTIVITIES = "MANAGE_SCHEDULED_ACTIVITIES",
  MARK_ACTIVITY_ATTENDANCE = "MARK_ACTIVITY_ATTENDANCE",
  ATTEND_SCHEDULED_ACTIVITIES = "ATTEND_SCHEDULED_ACTIVITIES",
  COMPLETE_PARTICIPANT_SHORTLISTING = "COMPLETE_PARTICIPANT_SHORTLISTING",
  EXHIBITOR_LISTING = "EXHIBITOR_LISTING",
  SPONSOR_LISTING = "SPONSOR_LISTING",
  ADD_TO_SCHEDULE_BY_ATTENDEE = "ADD_TO_SCHEDULE_BY_ATTENDEE",
  REQUEST_BY_EXHIBITOR = "REQUEST_BY_EXHIBITOR",
  ACTIVITIES_SCHEDULE = "ACTIVITIES_SCHEDULE",
  VIEW_ORGANIZATION_CONFIRMED_MEETINGS_CONNECTIONS = "VIEW_ORGANIZATION_CONFIRMED_MEETINGS_CONNECTIONS",
  ORG_SCHEDULE_CONNECTIONS = "ORG_SCHEDULE_CONNECTIONS",
  ORG_SCHEDULE = "ORG_SCHEDULE",
  VIEW_ORGANIZATION_CONFIRMED_MEETINGS = "VIEW_ORGANIZATION_CONFIRMED_MEETINGS",
  VIEW_ATTEND_SCHEDULE = "VIEW_ATTEND_SCHEDULE",
  CONTACT = "CONTACT",
  LEAD_CAPTURE_ADMIN = "LEAD_CAPTURE_ADMIN",
  TICKET_UPGRADE = "TICKET_UPGRADE",
  INVENTORY_APPLICABLE = "INVENTORY_APPLICABLE",
  UPDATE_EXHIBITOR_PROFILE = "UPDATE_EXHIBITOR_PROFILE",
  VIEW_MY_EXHIBITOR_PROFILE = "VIEW_MY_EXHIBITOR_PROFILE",
  EVENT_SUMMARY = "EVENT_SUMMARY",
  CUSTOM_EVENT_ACTION = "CUSTOM_EVENT_ACTION"
}

export const EventTimelineActionTypes = [DashboardActionType.FEEDBACK, DashboardActionType.UPDATE_EXHIBITOR_PROFILE];

export const SupportedEventAndTimelineAction = [
  DashboardActionType.EXHIBITOR_LISTING,
  DashboardActionType.SPONSOR_LISTING,
  DashboardActionType.CONTACT,
  DashboardActionType.LEAD_CAPTURE_ADMIN,
  DashboardActionType.VIEW_MY_EXHIBITOR_PROFILE,
  DashboardActionType.UPDATE_EXHIBITOR_PROFILE,
  DashboardActionType.FEEDBACK,
  DashboardActionType.EVENT_SUMMARY,
  DashboardActionType.CUSTOM_EVENT_ACTION
];
